<template>
    <modal :max-width="900" @close="$emit('close', multipleUsersData.endpoint && multipleUsersData.endpoint.name)">
        <div class="modal-box">
            <h4 class="pb-4">We've found multiple users for this email. Please select the correct agency:</h4>
            <div v-for="(data, index) in multipleUsersData.data" :key="index" class="multiple-users-box">
                <div class="row multiple-users-box">
                    <div class="col-md-4">
                        <p class="type">Agency name:</p>
                        <p class="value">{{ data.agencyName }}</p>
                    </div>
                    <div class="col-md-5">
                        <p class="type">Agency email:</p>
                        <p class="value">{{ data.agencyEmail }}</p>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-success" @click="submit(data)">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import modal from '@/components/common/Modal.vue'

export default {
    components: { modal },
    props: {
        multipleUsersData: Object
    },
    methods: {
        submit(data) {
            const submitObject = {
                endpoint: this.multipleUsersData.endpoint,
                data: data
            }
            this.$emit('close')
            this.$emit('submit', submitObject)
        }
    }
}
</script>
<style lang="scss">
.modal-box {
    padding: 24px;
  .multiple-users-box {
    margin-bottom: 18px;
    padi
    .type {
      margin-bottom: 0;
      font-size: 14px;
    }
    .value {
      margin-bottom: 0;
      font-size: 16px;
      font-weight: bold;
      opacity: 0.84;
    }
  }
}
</style>